/** @file Confidence 0..1 → whole percent and a low / medium / high band (AUTORIG_LIMITS thresholds). */
import { AUTORIG_LIMITS } from './autorigLimits.data';

/** `percent` is rounded to a whole number; NaN counts as 0. */
export function confidenceBand(confidence: number): { percent: number; band: 'low' | 'medium' | 'high' } {
  const c = Number.isFinite(confidence) ? Math.min(1, Math.max(0, confidence)) : 0;
  const band = c < AUTORIG_LIMITS.low ? 'low' : c < AUTORIG_LIMITS.high ? 'medium' : 'high';
  return { percent: Math.round(c * 100), band };
}
